module.exports = __webpack_public_path__ + "img/epicycloid_info_durer.db1366cb.jpg";